import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCardWalletFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.25 9.625a.3.3 0 0 1-.3.3H4.05a.3.3 0 0 1-.3-.3V8.011a3.574 3.574 0 0 1 3.57-3.57h9.36a3.574 3.574 0 0 1 3.57 3.57zm-4.268 6.788a1.585 1.585 0 1 1 0-3.173 1.586 1.586 0 1 1 0 3.173m.698-13.472H7.32a5.075 5.075 0 0 0-5.07 5.07v7.98a5.076 5.076 0 0 0 5.07 5.071h9.36a5.06 5.06 0 0 0 4.244-2.313l.07-.036v-.092c.47-.769.756-1.664.756-2.63v-7.98a5.075 5.075 0 0 0-5.07-5.07"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.999 5.767a686 686 0 0 0-4.623 2.954c-.167.108-.09.367.11.367h10.49a.3.3 0 0 0 .253-.46l-1.035-1.65a3.777 3.777 0 0 0-5.195-1.21"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCardWalletFilled);
export default ForwardRef;
